import $http from '../../shared/http';

export default {
  namespaced: true,
  state: () => {
    return {
      financialApprovers: [],
      financialApprovalStatusesForSelect: [],
    };
  },
  getters: {
    getFinancialApprovers: (state) => state.financialApprovers,
    getFinancialApprovalStatusesForSelect: (state) => state.financialApprovalStatusesForSelect,
  },
  mutations: {
    setFinancialApprovers: (state, payload) => (state.financialApprovers = payload),
    setFinancialApprovalStatusesForSelect: (state, payload) =>
      (state.financialApprovalStatusesForSelect = payload),
    removeFinancialApprover: (state, payload) => {
      const index = state.financialApprovers.findIndex((approver) => approver.id === payload);
      state.financialApprovers.splice(index, 1);
    },
  },
  actions: {
    async LOAD_FINANCIAL_APPROVERS({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/financial-approvers`, { canBeImpersonated: true })
          .then((response) => {
            commit('setFinancialApprovers', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async ADD_FINANCIAL_APPROVERS(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('financial-approvers', { ...payload }, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async ADD_REQUIRED_FINANCIAL_APPROVER(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(
            'financial-required-approvers',
            { ...payload },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async DELETE_FINANCIAL_APPROVER({ commit }, approver) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .delete(`financial-approvers/${approver.id}`, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            commit('removeFinancialApprover', approver.id);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async APPROVAL_ACTION(ctx, form) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`financial-approvals`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async DELETE_FINANCIAL_APPROVAL_ACTION({ dispatch }, { id, type, entityId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .delete(`financial-approvals/${id}`, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            await dispatch('LOAD_FINANCIAL_BUDGET_OR_REQUEST', { type, id: entityId });
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async LOAD_FINANCIAL_APPROVAL_STATUSES_FOR_SELECT({ commit }, { orgId }) {
      return $http('v2')
        .get(`organisations/${orgId}/financial_approval_statuses`)
        .then((response) => {
          commit('setFinancialApprovalStatusesForSelect', response.data.data);
          return response;
        });
    },
    async LOAD_FINANCIAL_BUDGET_OR_REQUEST({ dispatch }, { type, id }) {
      if (type === 'budget') {
        await dispatch('financial_budgets/LOAD_FINANCIAL_BUDGET', id, { root: true });
      } else {
        await dispatch('financial_requests/LOAD_FINANCIAL_REQUEST', id, { root: true });
      }
    },
  },
};
